module.exports = __webpack_public_path__ + "media/images/testimonial3-5b86cfd8696b10cfe16cb6d5d3fb5ce3.png";